import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Product } from '../../types/product';
import { ProductCard } from './ProductCard';
type ProductSectionProps = {
  title: string;
  subtitle?: string;
  link?: {
    to: string;
    label: string;
  };
  products: Product[];
};
export function ProductSection({
  title,
  subtitle,
  link,
  products
}: ProductSectionProps) {
  return <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-349" data-mp="37e31115mkrqz">
      <div className="mb-8 flex items-end justify-between gap-6" data-id="element-350" data-mp="3cburrruja7tl">
        <div data-id="element-351" data-mp="3ca1u321wexxq">
          <h2 className="text-3xl font-semibold tracking-display text-ink sm:text-4xl" data-id="element-352" data-mp="2xevp8iejh55z">{title}</h2>
          {subtitle && <p className="mt-2 text-muted" data-id="element-353" data-mp="32doszj40xhsy">{subtitle}</p>}
        </div>
        {link && <Link to={link.to} className="group hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-ink sm:inline-flex" data-id="element-354" data-mp="1lzow6h0h689x">
            {link.label}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-355" data-mp="1nojk6xod8sti" />
          </Link>}
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4 lg:gap-x-6" data-id="element-356" data-mp="1irb18uve8kr7">
        {products.map(p => <li key={p.slug} data-id="element-357" data-mp="1wnerkd35c8ye">
            <ProductCard product={p} data-id="element-358" data-mp="1rqocnt32vjek" />
          </li>)}
      </ul>
      {link && <Link to={link.to} className="mt-10 flex h-12 items-center justify-center rounded-full border border-ink text-sm font-medium sm:hidden" data-id="element-359" data-mp="26np55yt3fie3">
          {link.label}
        </Link>}
    </section>;
}